import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MessageService } from 'src/app/common/message.service';
import { SharedService } from 'src/app/services/shared.service';
import { HTTPService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Constants } from 'src/app/common/Constants';
import { MainMenuToggleService } from 'src/app/services/utility.service';
import { HowItWorksComponent } from '../howitworks/howitworks.component';
import { LoginComponent } from '../Login/Login.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FooterService } from 'src/app/footer.service';

declare var $: any;
@Component({
  selector: 'main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {
  subscription = new Subscription();
  userDetails: any = {};
  ProfileImage: any = {};
  Name: any = {};
  public constants: Constants;
  public isMenuCollapsed: boolean = false;
  logOut = false;
  public messageType: any;
  CategoryData: any = [];
  CardCategoryData: any = [];
  cards = 'cards';
  siteURL = environment.siteURL;
  assetURL = environment.cloudFrontAssetURL;
  searchterm = '';
  dropdownOpen = false;
  showHeader = true;
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
  constructor(
    private dialog: MatDialog,
    private _router: Router,
    private _httpService: HTTPService,
    public mainMenuToggleService: MainMenuToggleService,
    public sharedService: SharedService,
    public toastr: ToastrService,
    private ngbModel: NgbModal,
    private footerService: FooterService,
    private cdRef: ChangeDetectorRef
  ) {
    this.constants = new Constants();
    this.ProfileImage = this.assetURL + '/assets/images/avatars/avatar-1.jpg';
    this.Name = 'Guest';
    this.messageType = this.constants.messageType;
    this.mainMenuToggleService.menuSubject.subscribe(
      (value) => (this.isMenuCollapsed = value)
    );
    this.sharedService.loginMessageSubject.subscribe((data: any) => {
      if (data) {
        this.fillLoginData();
      }
    });
    this.fillLoginData();
    this.GetCategoryDataList();
    //this.GetCardCategoryDataList();
  }
  closeMenu() {
    const navbarToggler = document.querySelector(
      '.navbar-toggler'
    ) as HTMLElement;
    const navbarCollapse = document.querySelector(
      '.navbar-collapse'
    ) as HTMLElement;

    if (navbarToggler && navbarCollapse.classList.contains('show')) {
      navbarToggler.click(); // Simulates toggling the menu closed
    }
  }
  ngAfterViewInit() {
    const dropdownItems = document.querySelectorAll('.dropdown-item');
  
    dropdownItems.forEach(item => {
      item.addEventListener('click', () => {
        const navbarCollapse = document.querySelector('.navbar-collapse') as HTMLElement;
        if (navbarCollapse.classList.contains('show')) {
          navbarCollapse.classList.remove('show');
        }
      });
    });
  }
  public GetCategoryDataList() {
    if (
      this.sharedService.videoCategoryData == null ||
      this.sharedService.videoCategoryData == undefined
    ) {
      this._httpService
        .ajaxPost('homepage/GetCategoryData', { pCategoryId: '0' })
        .subscribe(
          (data) => {
            if (data['Message'].MessageTypeValue == this.messageType.Success) {
              this.CategoryData = data['CategoryData'];
              this.sharedService.videoCategoryData = this.CategoryData;
              this.sharedService.isVideoCategoryDataAvailable.next(true);
            } else {
              //  this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
            }
          },
          (error: any) => {
            // this.hideSpinner();
            // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
          }
        );
    }
  }
  public GetCardCategoryDataList() {
    this._httpService
      .ajaxPost('homepage/GetCardCategoryData', { pCardCategoryId: '0' })
      .subscribe(
        (data) => {
          if (data['Message'].MessageTypeValue == this.messageType.Success) {
            this.CardCategoryData = data['CardCategoryData'];
          } else {
            //  this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
          }
        },
        (error: any) => {
          // this.hideSpinner();
          // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
        }
      );
  }
  fillLoginData() {
    if (
      localStorage['userDetails'] != undefined &&
      localStorage['userDetails'] != null &&
      localStorage['userDetails'] != ''
    ) {
      this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
      this.Name = this.userDetails.Name;
      this.sharedService.isUserASeller =
        this.userDetails.IsSeller == true ? true : false;
      if (
        this.userDetails.ProfileImage != undefined &&
        this.userDetails.ProfileImage != null &&
        this.userDetails.ProfileImage != ''
      ) {
        this.ProfileImage = this.userDetails.ProfileImage;
      }
    }
  }

  getInitials(name: string): string {
    if (!name) return '';
    const initials = name
      .split(' ')
      .map((n) => n[0])
      .join('');
    return initials.toUpperCase();
  }

  ngOnInit() {
    // loginTime.setTime(loginTime.getTime() + this.constants.SessionTimeOut *60*1000);
    // if(loginTime < new Date(Date.now()))
    // {
    //   localStorage.clear();
    //   $("#profileImageTag").attr('src', "assets/images/avatars/avatar-1.jpg");
    // }
    // else{
    //   if (localStorage["userDetails"] != undefined && localStorage["userDetails"] != null && localStorage["userDetails"] != '')
    //   {
    //     localStorage.setItem("userLoginTime", Date.now().toString());
    //   }
    // }
    this.footerService.showHeaderFooter$.subscribe(show => {
      this.showHeader = show;
      this.cdRef.detectChanges(); // Force Angular to re-run change detection
    });
  }

  openDialog(isSellerLogin: boolean = false): void {
    // const modelRef = this.dialog.open(LoginComponent, { width: '420px' });
    // modelRef.componentInstance.isFromSellerLogin = isSellerLogin;
    // modelRef.afterClosed().subscribe((data) => {
    //   if (isSellerLogin) {
    //     this._router.navigate(['affiliate']);
    //   }
    // });

    const modelRef = this.ngbModel.open(LoginComponent, {
      size: 'lg',
      windowClass: 'login-dialog',
    });
    modelRef.componentInstance.isFromSellerLogin = isSellerLogin;
    modelRef.result.then((data) => {
      if (isSellerLogin) {
        this._router.navigate(['affiliate']);
      }
    });
  }

  redirectToSellerInfo() {
    this._router.navigate(['/user/affiliateinfo']);
    $('#resourcestitle').removeClass('show');
  }
  openHowItWorksDialog(): void {
    //this.dialog.open(HowItWorksComponent, { width: '1000px' })

    let dialogRef = this.dialog.open(HowItWorksComponent, {
      disableClose: true,
      width: '1000px',
      maxWidth: '100vw',
    });
    dialogRef.componentInstance.videoPath =
      'http://localhost:59987/UserData/User_6/VideoTemplate/Vid_1599234753.mp4';
  }

  Logout() {
    this.logOut = true;
    //localStorage.clear();
    localStorage.removeItem('setupTime');
    localStorage.removeItem('userDetails');
    $('#profileImageTag').attr(
      'src',
      this.assetURL + '/assets/images/avatars/avatar-1.jpg'
    );
    var pathString = location.pathname;
    if (pathString == '/') {
      location.reload();
    } else {
      this._router.navigate(['/']);
      this.userDetails = {};
      //location.reload();
    }
    $('#resourcestitle').removeClass('show');
  }

  MyVideos() {
    this._router.navigate(['/user/myvideos']);
    $('#resourcestitle').removeClass('show');
  }
  redirectToSellerConsole() {
    this._router.navigate(['/user/affiliateconsole']);
    $('#resourcestitle').removeClass('show');
  }

  openMenu(): void {
    this.mainMenuToggleService.onMenuToggle();
  }
  redirectToHomePage() {
    this._router.navigate(['/']);
  }
  search() {
    this.subscription.add(
      this._httpService
        .ajaxPost(
          `search/isSerchResultAvailable?searchterm=${this.searchterm}`,
          null
        )
        .subscribe(
          (data) => {
            if (data) {
              this._router.navigate([`/user/search/${this.searchterm}`]);
            } else {
              this.toastr.error(
                `No result available for given search. Please look into relevant category becuase your search for ${this.searchterm} might available under different title.`
              );
            }
          },
          (error: any) => {}
        )
    );
  }
  keyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search();
    }
  }
  redirectToCategory(item) {
    let encryptedqueryparams: { categoryId: any; subCategoryId: any };
    encryptedqueryparams = {
      categoryId: true,
      subCategoryId: 0,
    };
    // this._router.navigate(['/']);
    this._router.navigate([
      `${this.siteURL}${item.CategoryDesc.replace(
        / +/g,
        '-'
      )}/videos-invitation-maker/${this.sharedService.encryptData(
        JSON.stringify(encryptedqueryparams)
      )}`,
    ]);
  }
}
